module.exports = __webpack_public_path__ + "img/footer-logo.502ecd9f.png";